module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[57]178.8af9572.woff2";